import { ButtonType, ButtonWidget, InteractionState } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../codegen/Localize';
import { LeftNavCollapseExpandClickEvent, TelemetryEvents } from '../../common/telemetryEvents/TelemetryEvents';
import { imgPath } from '../../common/utilities/ImgUrl';
import { Telemetry } from '../../commonInfra/services/Telemetry';
import { getAppStore } from '../AppStore';
import { selectLayoutType } from '../selectors/LayoutTypeSelector';
import { LeftNavVisibility } from './LeftNav';
import { NavStyles } from './NavigationStyles';

// The button to open/close/minimize the navigation panel, whether it's in a dropdown or in the sidebar/leftnav
// When we have the mobile navigation dropdown, PanelState will include those states (open/close) as well
export type PanelState = LeftNavVisibility;

export const CollapseLeftIcon = imgPath('spaces_toolbar_back_black.svg');
export const CollapseLeftIconActive = imgPath('spaces_toolbar_back_black_active.svg');
export const ExpandRightIcon = imgPath('spaces_toolbar_forward.svg');
export const ExpandRightIconActive = imgPath('spaces_toolbar_forward_active.svg');

interface IconPaths {
  active: string;
  normal: string;
}

interface Icons {
  expanded: IconPaths;
  collapsed: IconPaths;
}

const icons: Icons = {
  expanded: {
    active: ExpandRightIconActive,
    normal: ExpandRightIcon
  },
  collapsed: {
    active: CollapseLeftIconActive,
    normal: CollapseLeftIcon
  }
};

export interface NavPanelButtonProps {
  readonly panelState: PanelState;
  readonly visibleVerticalScroll: boolean;
  readonly panelOpenMessage: string;
  readonly toggleNavPanel: () => void;
}

export class NavPanelButton extends React.Component<NavPanelButtonProps> {
  public render(): JSX.Element {
    return (
        <div className={NavStyles.LeftPanelButton}>
          <ButtonWidget
            buttonType={ButtonType.DarkBoldText}
            getContent={this.getButtonContent}
            title={this.isPanelOpen() ? Messages.leftNavToggleButtonCollapseTitle() : Messages.leftNavToggleButtonExpandTitle()}
            testId={this.isPanelOpen() ? 'close-left-nav' : 'open-left-nav'}
            handleClick={this.onClick}
            style={NavStyles.ButtonStyle}
          />
        </div>
    );
  }

  private onClick = () => {
    Telemetry.sendEvent<LeftNavCollapseExpandClickEvent>({
      type: TelemetryEvents.LeftNavCollapseExpandClick,
      action: this.isPanelOpen() ? 'collapse' : 'expand',
      layoutType: selectLayoutType(getAppStore().getState())
    });
    this.props.toggleNavPanel();
  }

  private getButtonContent = (interactiveState: InteractionState): JSX.Element => {
    const iconPaths = this.isPanelOpen() ? icons.collapsed : icons.expanded;
    return(
      <div className={NavStyles.getButtonContentClassNames(this.props.visibleVerticalScroll)}>
        <img
          src={interactiveState.hover || interactiveState.active ? iconPaths.active : iconPaths.normal}
          className={NavStyles.ButtonContentIcon}
          alt={this.isPanelOpen() ? Messages.leftNavToggleButtonCollapseTitle() : Messages.leftNavToggleButtonExpandTitle()}
        />
      </div>
    );
  }

  private isPanelOpen() {
    return this.props.panelState === 'expanded';
  }
}
